/**
 * This return uppercase string containing initials of firstName and lastName
 * @param firstName
 * @param lastName
 * @returns {string}
 */
export default (firstName, lastName, email) => {
  let str = ''
  if (firstName && lastName) {
    str = firstName[0] + lastName[0]
  } else if (firstName) {
    str = firstName[0]
  } else if (lastName) {
    str = lastName[0]
  } else if (email) {
    str = email[0]
  }
  return str.toUpperCase()
}
